export default __webpack_public_path__ + "static/media/ConsultVision_logo.4f167bf3.svg";